import { DeviceInfoBridge, type DeviceInfo } from '@/bridge/device-info.bridge';

export class DeviceInfoLocalService {
  static async getDeviceInfo(): Promise<DeviceInfo> {
    return DeviceInfoBridge.getDeviceInfo();
  }
  static async getLanguageCode(): Promise<string> {
    return DeviceInfoBridge.getLanguageCode();
  }
}
